import {cache, inlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'
import {isServer} from '@adv-mt/mt-utils'

/**
 * @implements UseCase
 */
class GetSearchResultsAdsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Object} deps.service
   */
  constructor({config, service}) {
    super({config, service})
    this._config = config
    this._service = service
  }

  @tracer({metric: 'GetSearchResultsAdsUseCase#execute'})
  @cache({
    server: isServer,
    ttl: '100 seconds',
    cacheKeyString: 'GetSearchResultsAdsUseCase#execute'
  })
  @inlineError
  async execute(params = {}) {
    const [getSearchResultsServiceError, getSearchResultsServiceResponse] = await this._service.execute(params)

    return getSearchResultsServiceError
      ? Promise.reject(getSearchResultsServiceError)
      : getSearchResultsServiceResponse.toJSON()
  }
}

export default GetSearchResultsAdsUseCase
